import {
  useCallback,
  useEffect,
} from 'react';
import { useEventContext } from './EventProvider';

export interface UseEventHookTrigger {
  (data: any): void;
}

export interface UseEventHookHandler {
  (data: any): void;
}

export interface UseEventHook {
  (event: string, handler?: UseEventHookHandler): UseEventHookTrigger
}

export const useEvent: UseEventHook = (event, handler) => {
  const { emit, on, remove } = useEventContext();

  const onEvent = useCallback(
    (data: any) => {
      handler?.(data);
    },
    [handler],
  );

  useEffect(() => {
    on(event, onEvent);

    return () => {
      remove(event, onEvent);
    };
  }, [event, onEvent]);

  return (data: any) => emit(event, data);
};
